export default __webpack_public_path__ + "static/media/python.9469a25c.svg";